export const alphavantageConfig = {
  apiKey: 'Q8ZI5UJX6WTQ6KW0',
  baseUrl: 'https://www.alphavantage.co/query'
};
